// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".InstaFeed{display:flex}.InstaFeed-Scroll{overflow-x:auto}.InstaFeed img{position:static;display:block;height:auto;padding-bottom:0;margin-left:1px;min-width:156px}.InstaFeed img:first-of-type{margin-left:0}.InstaFeed img:last-of-type{margin-right:0}\n", ""]);
// Exports
module.exports = exports;
